export default {"src":"/_next/static/media/worstelen.f008e9c2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};